import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';

const CurrencyContext = createContext('€');

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState('€');

  useEffect(() => {
    api.get('/branding')
      .then(({ data }) => { if (data.currency) setCurrency(data.currency); })
      .catch(() => {});
  }, []);

  return (
    <CurrencyContext.Provider value={currency}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
